module.exports = __webpack_public_path__ + "static/media/listArms.d566ace3.png";